import { types, flow } from 'mobx-state-tree'
import * as ChatService from "~/services/chat"

const SBUser = types
  .model('SBUser', {
    // A user's unique ID. The length is limited to 80 characters
    user_id: types.maybeNull(types.string),
    // A user's nickname. The length is limited to 80 characters
    nickname: types.maybeNull(types.string),
    // The URL of a user's profile image
    profile_url: types.maybeNull(types.string),
    // An opaque string that identifies the user
    access_token: types.maybeNull(types.string),
    // Indicates whether the user has ever logged into the chat application
    has_ever_logged_in: types.maybeNull(types.boolean),
    // Indicates whether the user is active within the Sendbird application
    is_active: types.maybeNull(types.boolean),
    // Indicates whether the user is connected to the Sendbird server
    is_online: types.maybeNull(types.boolean),
    discovery_keys: types.maybeNull(types.array(types.string)),
    preferred_languages: types.maybeNull(types.array(types.string)),
    // The time that the user was created in Unix milliseconds format
    created_at: types.maybeNull(types.number),
    // The time the user went offline in Unix milliseconds
    last_seen_at: types.maybeNull(types.number),
    // A JSON object of one or more key-value items to store additional user information such as phone number, email or a long description of the user.
    metadata: types.maybeNull(types.frozen({})),
  })
  .views(self => ({
    // get testGetter() {
    //   return "Some calculated user value"
    // },
  }))
  .actions(self => ({
    // Retrieves a list of customers registered in the application:
    createUser: flow(function* createUserGen() {
      yield ChatService.createUser()
    }),
  }))

export default SBUser
